import apiFetch from '@wordpress/api-fetch';
import { __ } from "@wordpress/i18n";
import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { formDataPost } from '../helpers/Helpers';
import withForm from '../layouts/withForm';
const Security2faList = ({handleChange}) => {
    const [selectedRows, setSelectedRows] = useState([])
    const [bulkAction, setBulkAction] = useState("-1")
    const [userList,setUserList] = useState([])
    const [records, setRecords] = useState([])
    const [roleList,setRoleList] = useState([])
    const [activeRole, setActiveRole] = useState('')
    const [searchQuery,setSearchQuery] = useState('')
    const [reload, setReload] = useState(0);
    const columns =  [
        { 
            id: 'username',
            name: 'Username',
            cell: row => (
                <div className="d-flex flex-wrap align-items-center gap-2">
                    <img src={row.data.avatar} alt={row.data.display_name} width="40" height="40" />
                    <span><b>{row.data.user_login}</b></span>
                </div>
            ),

        },
        {
            id: 'user_registered',
            name: 'Created Date',
            selector: row => row.data.user_registered,
            sortable: true,
        },
        { 
            id: 'ultimate-security-2fa-provider',
            name: '2FA Type',
            selector: row => row.data.user_meta['ultimate-security-2fa-provider']?row.data.user_meta['ultimate-security-2fa-provider']:'N/A',
            sortable: true,
        },
        { 
            id: 'action',
            name: 'Action',
            cell: row => (
                <div className="d-flex align-items-center gap-2">
                    {/* <img
                        src={ultimate_security_ajax_obj.imageUrl+'reset.svg'}
                        className="cursor-pointer"
                        onClick={() => handleClick2faReset(row.ID)}
                    /> */}
                    <img
                        src={ultimate_security_ajax_obj.imageUrl+'delete.svg'}
                        className="cursor-pointer"
                        // onClick={() => handleClick2faDelete(row.ID)}
                        onClick={() => handleClick2faReset(row.ID)}
                    />
                </div>
            ),
            ignoreRowClick: true, // Prevent triggering row click event
            allowoverflow: true, // Ensure it doesn’t interfere with other UI
            button: true, // Ensures proper styling for buttons

            style: {display: 'flex', justifyContent: 'end', paddingRight: '11px', gap: '8px'}
        }
    ]

    useEffect(() => {
        const baseURL = '/ultimate-security/v1';        

        const getRoleData = async () => {
            try {
                const response = await apiFetch({
                    path: `${baseURL}/get-roles`,
                    method: 'GET'
                });

                const rolesArray = Object.entries(response).map(([key, value]) => ({
                    role: key,
                    ...value
                }));
                
                setRoleList(rolesArray);

            } catch (error) {
                // console.log(error);
            }
        };
        getRoleData();
    },[])
    
    useEffect(() => {
        const baseURL = '/ultimate-security/v1';        
        const getUserData = async () => {
            try {
                const response = await apiFetch({
                    path: `${baseURL}/get-users`,
                    method: 'GET'
                });
        
                setUserList(response);
                setRecords(response);
        
            } catch (error) {
                // console.log(error);
            }
        };
        getUserData();
    },[reload])

    const handleSelectedRowsChange = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
        // console.log(selectedRows)
    };
    const handleUserSearch = (e) => {
        setSearchQuery(e.target.value)
        setActiveRole('') // Reset the active role
        const newData = userList.filter(row => {
            return row.data.user_login.toLowerCase().includes(e.target.value.toLowerCase())
        })
        setRecords(newData)
    }
    const handleUserFilter = (role) => {
        setSearchQuery('')
        if (role == 'All') {
            setRecords(userList)        
            setActiveRole(''); // Set the active role
        } else {
            const newData = userList.filter(row => {
                return row.data.role.toLowerCase().includes(role.toLowerCase())
            })
            setRecords(newData)        
            setActiveRole(role); // Set the active role
        }
    }
    const handleClick2faReset = async (user_id) => {        
        // console.log("Reset 2fa for: ", user_id)
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            try {
                const result = await formDataPost('ultimate_security_user_2fa_reset',{"user_id": user_id});
                // console.log(result);
                if (result.success_message) {
                    setReload(Math.random);    
                }
            } catch (error) {
                // console.log(error.message);
            } finally {}
        }
    }
    const handleClick2faResetAll = async () => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            try {
                const result = await formDataPost('ultimate_security_user_2fa_reset_all',{});
                // console.log(result);
                if (result.success_message) {
                    setReload(Math.random);    
                }
                    
            } catch (error) {
                // console.log(error.message);
            } finally {}
        }
    }
    const handleClick2faDelete = (user_id) => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            // console.log("Delete 2fa for: ", user_id)
        }
    }
    
    const handleClick2faDeleteAll = () => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            // console.log("Delete all 2fa")
        }
    }
    const handleBulkActionChange = (e) => {
        setBulkAction(e.target.value);
    };    
    const handleBulkActionSubmit = async () => {
        if (selectedRows.length) {
            const ids = selectedRows.map(item => item.ID);           

            if (bulkAction === "reset") {
                const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
                if (confirmed) {
                    try {
                        const result = await formDataPost('ultimate_security_user_2fa_reset_users',{"user_ids": ids});
                        // console.log(result);
                        if (result.success_message) {
                            setReload(Math.random);    
                        }
                            
                    } catch (error) {
                        // console.log(error.message);
                    } finally {}
                }

            } else if (bulkAction === "delete") {
                const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
                if (confirmed) {
                    try {
                        const result = await formDataPost('ultimate_security_user_2fa_reset_users',{"user_ids": ids});
                        // console.log(result);
                        if (result.success_message) {
                            setReload(Math.random);    
                        }
                            
                    } catch (error) {
                        // console.log(error.message);
                    } finally {}
                }

            } else {
                alert("Please select a valid action.");
            }
        } else {
            alert("Please select users.");
        }
    };
    return (
        <>
            <div className="setting-unit">
            <div className="user-datatable datatable-unit">
            <div className="row justify-content-between mb-30">
                <div className="col-8 filters">
                    <div className="d-flex flex-wrap wp-roles">
                        <span
                            onClick={() => handleUserFilter('All')}
                            className={activeRole === '' ? 'active' : ''} // Apply active class conditionally
                            >All</span>
                        {
                            roleList && roleList.map(item=> (                                        
                                item?.count ? 
                                <span 
                                    key={item.role} 
                                    value={item.role} 
                                    onClick={() => handleUserFilter(item.name)}
                                    className={activeRole === item.name ? 'active' : ''} // Apply active class conditionally
                                >
                                {item.name} ({item.count})
                                </span> 
                                : ''                                        
                            ))      
                        }
                    </div>
                    <div className="bulk-action-wrapper">
                        <select value={bulkAction} name="action"  onChange={handleBulkActionChange}>
                            <option value="-1">{__( 'Bulk actions', 'ultimate-security' )}</option>
                            {/* <option value="reset">{__( 'Reset', 'ultimate-security' )}</option> */}
                            <option value="delete">{__( 'Delete 2FA', 'ultimate-security' )}</option>
                        </select>
                        <button className="button button-secondary" onClick={handleBulkActionSubmit}>{__( 'Apply', 'ultimate-security' )}</button>
                    </div>
                </div>
                <div className="col-auto">
                    <div className="search-unit d-flex gap-2 align-items-center">
                        <input placeholder="Search Users" type="search" onChange={handleUserSearch} value={searchQuery} />
                        <button className="button button-secondary" type="button">{__( 'Search', 'ultimate-security' )}</button>
                    </div>
                    <div className="action-buttons d-flex align-items-center">
                        {/* <span onClick={handleClick2faResetAll}>{__( 'Reset All 2FA', 'ultimate-security' )}</span> */}
                        {/* <span onClick={handleClick2faDeleteAll}>{__( 'Delete All 2FA', 'ultimate-security' )}</span> */}
                        <span onClick={handleClick2faResetAll}>{__( 'Delete All 2FA', 'ultimate-security' )}</span>
                    </div>
                </div>
            </div>            
            <div className="table-wrapper">
                <DataTable
                    columns={columns}
                    data={records}
                    selectableRows // for making row selectable
                    onSelectedRowsChange={handleSelectedRowsChange} // Handle row selection changes  
                    pagination
                    dense
                    responsive
                />
            </div> 
        </div> 
            </div>
        </>
    )
}
export default withForm(Security2faList);